// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import { toast } from 'react-toastify';
// import Select from 'react-select';

// import Button from './PlanEditor/Button';
import Search from '../Search';
import ConfirmCaution from '../Modals/ConfirmCaution';
import copy from '../../utilities/copy';


// const _2FA_OPTIONS = {
//     "": "Disabled",
//     "email": "Send code via email",
// };


export default class TeamUsers extends React.Component {

    state = {
        filter: "",
        showConfirmModal: false,
        modalData: {},
        newIp: "",
        addingIp: false
    }



    render = () => {

        const users = (this.props.users??[]).reduce((acc, user) => {
            if(!user.name.includes(this.state.filter) && !user.email.includes(this.state.filter))
                return acc; 

            return [...acc, user]
        }, []).sort((a, b) => {
            // First sort by status (pending first) 
            if (a.isPending && !b.isPending) return -1; 
            if (!a.isPending && b.isPending) return 1;
            
            // Else sort by name.  
            const nameA = a.name?.toLowerCase() || a.email.toLowerCase(); 
            const nameB = b.name?.toLowerCase() || b.email.toLowerCase(); 

            return nameA.localeCompare(nameB); 
        });

        return (<div className='settings-content'>
            <div className="files settings-users">
        
                <div style={{ width: '100%', height: 80 }}>
                    <Search
                        user={this.props.user}
                        query={this.state.filter}
                        search={filter => this.setState({ filter })}
                        className="title-input"
                        placeholder="Filter by name or email..."
                        style={{ width: 225 }}
                    />
                </div>

                {
                    users.map((user, idx) => {

                        const isOwner = this.props.owner === user._id;   
                        const isAdmin = user.isAdmin;  
                        const isSelf = user._id === this.props.user._id; 

                        return (
                            <div
                                className={'settings-user' + (user.isPending ? " settings-user-pending" : "")}   
                            >
                                {
                                    !isOwner && !isSelf && <img 
                                        className="settings-user-delete"
                                        alt="Delete"
                                        title="Delete this user permanently"
                                        src="https://static.stax.ai/images/icons/delete.png"
                                        onClick={() => this.setState({
                                            showConfirmModal: true,
                                            modalData: {
                                                message: <>
                                                    <strong>{user.isPending ? "This user" : user.name}</strong> will no longer have access to their <a href="https://stax.ai" target="_blank" rel="noopener noreferrer">Stax·ai</a> account or any documents in your team.
                                                </>,
                                                action: () => this.props.deleteUser(user._id)
                                            }
                                        })}
                                    />
                                }


                                <div
                                    key={idx}
                                    className={"settings-user-icon palette-color-" + String(idx % 8)}
                                >
                                    {user.name && user.name !== "" ? user.name.substring(0, 1) : user.email.substring(0, 1)}
                                    {isAdmin && <img
                                        className="settings-user-admin"
                                        src="https://static.stax.ai/images/icons/shield.png"
                                        alt="Admin"
                                    />}
                                </div>



                                <div className="settings-user-name-value">{user.isPending ? "(Pending Invitation)" : user.name}</div>

                                <div className="settings-user-email-value">{user.email}</div>

                                {!isSelf && 
                                    <div className="settings-user-options">
                                        <div
                                            style={{
                                                left: 10,
                                                backgroundImage: user.isAdmin? "url('https://static.stax.ai/images/toggle/admin.png')" : "url('https://static.stax.ai/images/toggle/user.png')"
                                            }}
                                            onClick={() => {
                                                if (user._id === this.props.user._id)
                                                    return toast.error("You cannot change your own admin privilege setting.");

                                                this.props.updateUser({
                                                    _id: user._id,
                                                    isAdmin: !user.isAdmin
                                                })
                                            }}
                                        >{user.isAdmin?"Admin":"User"}</div>

                                            <div
                                                className={isOwner || isSelf ? "settings-user-option-disabled" : ""}
                                                style={{
                                                    right: 10, 
                                                backgroundImage: user.isPending ? "url('https://static.stax.ai/images/icons/action-copy.png')" : "url('https://static.stax.ai/images/toggle/" + (user.isSuspended ? "reinstate" : "suspend") +".png')"
                                                }}
                                                onClick={() => {
                                                if(isOwner || isSelf) return // Option is disabled. 
                                                if(user.isPending){
                                                    copy(`https://my.stax.ai/invite/${user._id}`)
                                                    toast.info("Copied invite link to clipboard")
                                                    return
                                                }

                                                this.props.updateUser({
                                                    _id: user._id,
                                                    isSuspended: !user.isSuspended
                                                })
                                                }}
                                            >
                                            {
                                                user.isPending ? "Invite Link" : user.isSuspended ? "Reinstate" : "Suspend" 
                                        }
                                    </div>
                                    </div>
                                }

                            </div>
                        )
                    })
                }

                <div
                    className="settings-user settings-user-new"
                    onClick={this.props.inviteUser}
                >
                    <img
                        alt="Add"
                        src={"https://static.stax.ai/images/icons/" + (this.props.user && this.props.user.enableDarkMode ? "dark/" : "") + "create.png"}
                    />
                    <h1>Invite a new user</h1>
                </div>

                {this.state.showConfirmModal ? <ConfirmCaution
                    modal={() => this.setState({ showConfirmModal: false })}
                    data={this.state.modalData}
                /> : ""}
            </div>

            <div style={{ clear: 'both' }} />
        </div>);
    }
};